import { render, staticRenderFns } from "./ExternalPaidOrderBindList.vue?vue&type=template&id=57b408b3&scoped=true"
import script from "./ExternalPaidOrderBindList.vue?vue&type=script&lang=js"
export * from "./ExternalPaidOrderBindList.vue?vue&type=script&lang=js"
import style0 from "./ExternalPaidOrderBindList.vue?vue&type=style&index=0&id=57b408b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b408b3",
  null
  
)

export default component.exports